/**
 * @fileoverview syncscroll - enhanced scroll sync module
 * @version 0.0.4
 * @license MIT, original: http://github.com/asvd/intence
 */

const Width = 'Width'
const Height = 'Height'
const Top = 'Top'
const Left = 'Left'
const scroll = 'scroll'
const client = 'client'
const EventListener = 'EventListener'
const addEventListener = 'add' + EventListener
const removeEventListener = 'remove' + EventListener
const length = 'length'
const Math_round = Math.round

const names = {}
const scrollLocks = {}
const TOLERANCE = 1 // pixels

function throttle(fn, delay) {
  let lastCall = 0
  return function (...args) {
    const now = Date.now()
    if (now - lastCall >= delay) {
      lastCall = now
      fn.apply(this, args)
    }
  }
}

export function resetSyncscrollElements() {
  const elems = document.getElementsByClassName('sync' + scroll)

  // Clear old listeners
  for (const name in names) {
    if (names.hasOwnProperty(name)) {
      for (let i = 0; i < names[name][length]; i++) {
        names[name][i][removeEventListener](scroll, names[name][i].syn, {
          passive: true
        })
      }
    }
  }

  // Set up new listeners
  for (let i = 0; i < elems[length]; ) {
    let el = elems[i++]
    const name = el.getAttribute('name')
    const id = el.getAttribute('id')
    if (!name) continue

    el = el[scroll + 'er'] || el
    const group = (names[name] = names[name] || [])

    if (!group.includes(el)) {
      group.push(el)
    }

    el.eX = el.eY = 0
    scrollLocks[name] = false

    const handler = throttle(function () {
      if (scrollLocks[name]) return
      scrollLocks[name] = true
      const scrollX = el[scroll + Left]
      const scrollY = el[scroll + Top]

      // replaced rates with delta to have same scroll in both containers no matter the width
      // const xRate = scrollX / (el[scroll + Width] - el[client + Width] || 1)
      // const yRate = scrollY / (el[scroll + Height] - el[client + Height] || 1)
      const deltaX = scrollX - el.eX
      const deltaY = scrollY - el.eY

      const updateX = scrollX !== el.eX
      const updateY = scrollY !== el.eY

      el.eX = scrollX
      el.eY = scrollY

      for (let j = 0; j < group[length]; j++) {
        const otherEl = group[j]
        if (otherEl === el) continue
        if (updateX) {
          //   const newX = Math_round(
          //     xRate * (otherEl[scroll + Width] - otherEl[client + Width])
          //   )
          //   if (Math.abs(otherEl[scroll + Left] - newX) > TOLERANCE) {
          //     requestAnimationFrame(() => {
          //       otherEl[scroll + Left] = otherEl.eX = newX
          //     })
          //   }
          const newX = otherEl[scroll + Left] + deltaX
          requestAnimationFrame(() => {
            otherEl[scroll + Left] = otherEl.eX = newX
          })
        }

        if (updateY) {
          // const newY = Math_round(
          //   yRate * (otherEl[scroll + Height] - otherEl[client + Height])
          // )
          // if (Math.abs(otherEl[scroll + Top] - newY) > TOLERANCE) {
          //   requestAnimationFrame(() => {
          //     otherEl[scroll + Top] = otherEl.eY = newY
          //   })
          // }
          const newY = otherEl[scroll + Top] + deltaY
          requestAnimationFrame(() => {
            otherEl[scroll + Top] = otherEl.eY = newY
          })
        }
      }

      scrollLocks[name] = false
    }, 10)

    el[addEventListener](scroll, handler, { passive: true })
    el.syn = handler
  }
}

// Auto-init on load
if (document.readyState === 'complete') {
  resetSyncscrollElements()
} else {
  window[addEventListener]('load', resetSyncscrollElements, { passive: true })
}
